import { TranslationGroup } from '../i18n/tanslation-group';
import { mmCodeTableContants } from './code-table-constants';
import { en, zh } from './i18n';

export const mmCodeTableTranslationGroup = {
    groupName: mmCodeTableContants.translationGroup,
    translations: {
        "en": en,
        "zh": zh
    }

} as TranslationGroup